import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getPlatformAPI } from '../lib/platform'

/**
 * Bridges the "Mit HappyCloud verbinden" action triggered from the standalone
 * Electron preferences window into the MAIN window.
 *
 * The preferences window has its own renderer (separate sessionStorage + router),
 * so it can't run the connect flow itself. Instead its button invokes the
 * `connect-happycloud` IPC; the main process focuses this (main) window and
 * forwards the `connect-happycloud` event here, where we run the SAME flow as the
 * sidebar's "Mit HappyCloud verbinden" (UserAvatar.handleConnectCloud): set the
 * `forceSetupPage` flag and navigate to '/', so SetupRoute shows the login page
 * instead of redirecting an offline user straight back into the app. Local data
 * stays intact.
 *
 * Electron-only: web has no separate preferences window (and no `window.api`).
 */
export function useConnectCloud() {
  const navigate = useNavigate()

  useEffect(() => {
    if (getPlatformAPI().platform !== 'electron' || !window.api?.receive) return
    const cleanup = window.api.receive('connect-happycloud', () => {
      sessionStorage.setItem('forceSetupPage', 'true')
      navigate('/', { replace: true })
    })
    return () => {
      cleanup?.()
    }
  }, [navigate])
}
